import { InterpolationService, RangeStyle, LegendUtils as MapWaldLegendUtils } from "map-wald";
import { DATA_MODE_COMPARISON_ONLY, DATA_MODE_LABELS, DATA_MODE_SUFFIXES, DATA_MODE_TRENDS, DataMode, DataOverlay, FlattenedLayerDescriptor, LEGEND_UNITS, LegendResponse, TITLE_UNITS } from "./data";
import * as R from 'ramda';
import { makeColour, LegendConfig } from "map-wald-leaflet";
import * as d3 from 'd3-time-format';

// @dynamic
export class LegendUtils {
  static resetLegend(): LegendConfig {
    return {
      colours: [],
      labels: [],
      shape: []
    };
  }

  static makePointLegend(palette: string[], fill: RangeStyle<string>, layer?: FlattenedLayerDescriptor, units?:string,precision?:number): LegendConfig {
    let labels = layer?.legendLabels;
    units = units || layer?.units;
    if(units?.length >=8){
      units = '';
    }
    if(!labels){
      labels = MapWaldLegendUtils.getLabels(fill,precision,units);
    }
    return {
      colours: palette.slice().reverse(),
      labels: labels,// Should be significant digits
      shape: ['circle']
    };
  }

  static describeLegend(dataOverlay: DataOverlay,choropleth:boolean): {explanation:string,units:string,titleUnits:string} {
    const tp = dataOverlay.timePeriod;
    const layer = dataOverlay.selection.flattened;
    const dataMode = dataOverlay.selection.dataMode;

    const template = '{{variable}} {{aggregation}} for {{period}} {{endDate}} {{comparison}}';
    const variable = layer.description || layer.legendLabel || layer.variantLabel || layer.label;
    const isTimePeriod = tp.from.getTime() !== tp.to.getTime();
    let months = 0;
    if(isTimePeriod){
      months = 1 + (tp.to.getUTCFullYear() - tp.from.getUTCFullYear()) * 12 +
        tp.to.getUTCMonth() - tp.from.getUTCMonth();
    }
    let parameters: any = {
      variable: variable,
      aggregation: isTimePeriod? aggregationLabel(layer): '',
      period: isTimePeriod? `${months} months up to and including`: '',
      endDate: d3.timeFormat('%B %Y')(tp.to as Date),
      comparison: ''
    };
    if(dataMode!==DataMode.NORMAL){
      const comparisonTemplate = DATA_MODE_COMPARISON_ONLY[dataMode] ?
        '{{comparisonType}} {{comparisonPeriod}} {{variableRepeat}}{{suffix}}' :
        '{{comparisonType}} long term average {{comparisonPeriod}} {{variableRepeat}}{{suffix}}';
      let comparisonParameters:any = {
        comparisonType: DATA_MODE_LABELS[dataMode],
        comparisonPeriod: isTimePeriod?
                  `${d3.timeFormat('%B')(tp.from as Date)}-${d3.timeFormat('%B')(tp.to as Date)}`:
                  d3.timeFormat('%B')(tp.from as Date),
        variableRepeat: (layer.description && (dataMode!==DataMode.MEAN)) ? '' : variable.toLowerCase(),
        suffix: DATA_MODE_SUFFIXES[dataMode]||''
      };
      parameters.comparison = InterpolationService.interpolate(comparisonTemplate,comparisonParameters);
    }
    let result = {
      explanation: '',
      units: LEGEND_UNITS[dataMode]||layer.units,
      titleUnits: TITLE_UNITS[dataMode]||layer.units
    };

    if(DATA_MODE_COMPARISON_ONLY[dataMode]){
      result.explanation = parameters.comparison;
    } else {
      result.explanation = InterpolationService.interpolate(template,parameters);
    }

    if(DATA_MODE_TRENDS[dataMode]){
      result.units += '/y';
      if(choropleth){
        result.explanation += ' (only trends significant at p<0.05 are shown)';
      }
    }

    return result;
  }
}

function aggregationLabel(layer: FlattenedLayerDescriptor) {
  if(layer.summable){
    return 'total';
  }

  if(layer.aggregation==='mean'){
    return 'average';
  }
  return '';
}


